import { render, staticRenderFns } from "./EditAssistent.vue?vue&type=template&id=ad7b11fc&"
import script from "./EditAssistent.vue?vue&type=script&lang=js&"
export * from "./EditAssistent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports